import { useCallback, useRef } from 'react'

import { ShowToastOptions, useToast } from '@verbit-ai/verbit-ui-library'

import { announceText } from 'src/utils/announce'
import { getTextFromReactNode } from 'src/utils/text'

export const useToastWithAnnouncement = () => {
    const toasterRef = useRef(useToast())

    const showToast = useCallback((options: ShowToastOptions) => {
        const text = [options.title, options.description]
            .filter((s) => !!s)
            .map(getTextFromReactNode)
            .join('\n')
        if (text) {
            announceText(text)
        }

        toasterRef.current(options)
    }, [])

    return showToast
}
